<template>
    <div>
        <v-row class="justify-center align-center" no-gutters>
            <v-col cols="12" sm="6" class="d-flex justify-center">
                <v-img
                    :src="require('@/assets/anpc-sal.png')"
                    alt="ANPC SAL"
                    max-width="300"
                    contain
                    class="clickable-img"
                    @click="openLink('https://anpc.ro/ce-este-sal/')"
                />
            </v-col>
            <v-col cols="12" sm="6" class="d-flex justify-center">
                <v-img
                    :src="require('@/assets/anpc-sol.png')"
                    alt="ANPC SOL"
                    max-width="300"
                    contain
                    class="clickable-img"
                    @click="openLink('https://ec.europa.eu/consumers/odr')"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    name: "ANPCBanner",
    methods: {
        openLink(url) {
            window.open(url, "_blank");
        },
    },
};
</script>

<style scoped>
.v-img {
    border-radius: 8px;
}

.clickable-img {
    cursor: pointer;
    transition: transform 0.2s ease;
}

.clickable-img:hover {
    transform: scale(1.02);
}
</style>
